import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { LanguagePickerPageRoutingModule } from './language-picker-routing.module';

import { LanguagePickerPage } from './language-picker.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    LanguagePickerPageRoutingModule
  ],
  declarations: [LanguagePickerPage]
})
export class LanguagePickerPageModule {}
